function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { defineDocument } from "sanity-typed-queries";
import { PageType } from "@stereoagency/constants";
import { simpleHero, largeHero, mediaSection, keyFiguresSection, bigTitleSection, programsListSection, pictureAndContentSection, latestNewsGridSection, logoCarouselSection, stepListSection, simpleDatalistSection, imageGallerySection, simpleContentSection, reportsGridSection, teamSection, callToActionCardsGridSection, logoCardsGridSection, simpleCardsListSection, researchGroupListingSection, articleListingSection, eventListingSection, jobListingSection, diseaseListingSection, profileListingSection, departmentsSection, researchPlatformListingSection, contactSection, dividerSection, scrollAnchorSection, imageActionCardsSection, donationBoxSection, seoFields, legacySimulatorSection } from "../objects/index.js";
import documentSlug from "../fragments/documentSlug.js";
var schema = defineDocument("page", {
    slug: _object_spread({
        title: "Slug"
    }, documentSlug.factory()),
    pageType: {
        title: "Page Type",
        type: "string",
        options: {
            list: Object.values(PageType)
        }
    },
    title: {
        title: "Title",
        type: "string",
        validation: function(Rule) {
            return Rule.required();
        }
    },
    sections: {
        title: "Sections",
        type: "array",
        of: [
            {
                type: "simpleHero"
            },
            {
                type: "largeHero"
            },
            {
                type: "mediaSection"
            },
            {
                type: "keyFiguresSection"
            },
            {
                type: "bigTitleSection"
            },
            {
                type: "programsListSection"
            },
            {
                type: "pictureAndContentSection"
            },
            {
                type: "latestNewsGridSection"
            },
            {
                type: "logoCarouselSection"
            },
            {
                type: "stepListSection"
            },
            {
                type: "simpleDatalistSection"
            },
            {
                type: "imageGallerySection"
            },
            {
                type: "simpleContentSection"
            },
            {
                type: "teamSection"
            },
            {
                type: "callToActionCardsGridSection"
            },
            {
                type: "logoCardsGridSection"
            },
            {
                type: "simpleCardsListSection"
            },
            {
                type: "researchGroupListingSection"
            },
            {
                type: "articleListingSection"
            },
            {
                type: "eventListingSection"
            },
            {
                type: "jobListingSection"
            },
            {
                type: "diseaseListingSection"
            },
            {
                type: "profileListingSection"
            },
            {
                type: "departmentsSection"
            },
            {
                type: "researchPlatformListingSection"
            },
            {
                type: "contactSection"
            },
            {
                type: "dividerSection"
            },
            {
                type: "reportsGridSection"
            },
            {
                type: "scrollAnchorSection"
            },
            {
                type: "imageActionCardsSection"
            },
            {
                type: "donationBoxSection"
            },
            {
                type: "legacySimulatorSection"
            }
        ]
    },
    pattern: {
        title: "Pattern",
        type: "string",
        options: {
            list: [
                "1",
                "2",
                "3"
            ]
        }
    },
    seo: {
        title: "SEO",
        type: "seoFields"
    },
    language: {
        title: "Language",
        type: "string",
        readOnly: true,
        description: 'Use the "translations" menu to assign a language',
        validation: function(Rule) {
            return Rule.required();
        }
    }
}, [
    seoFields.schema.seoFields,
    largeHero.schema.largeHero,
    simpleHero.schema.simpleHero,
    mediaSection.schema.mediaSection,
    keyFiguresSection.schema.keyFiguresSection,
    bigTitleSection.schema.bigTitleSection,
    programsListSection.schema.programsListSection,
    pictureAndContentSection.schema.pictureAndContentSection,
    latestNewsGridSection.schema.latestNewsGridSection,
    logoCarouselSection.schema.logoCarouselSection,
    stepListSection.schema.stepListSection,
    simpleDatalistSection.schema.simpleDatalistSection,
    imageGallerySection.schema.imageGallerySection,
    simpleContentSection.schema.simpleContentSection,
    reportsGridSection.schema.reportsGridSection,
    teamSection.schema.teamSection,
    callToActionCardsGridSection.schema.callToActionCardsGridSection,
    logoCardsGridSection.schema.logoCardsGridSection,
    simpleCardsListSection.schema.simpleCardsListSection,
    researchGroupListingSection.schema.researchGroupListingSection,
    articleListingSection.schema.articleListingSection,
    eventListingSection.schema.eventListingSection,
    jobListingSection.schema.jobListingSection,
    diseaseListingSection.schema.diseaseListingSection,
    profileListingSection.schema.profileListingSection,
    departmentsSection.schema.departmentsSection,
    researchPlatformListingSection.schema.researchPlatformListingSection,
    contactSection.schema.contactSection,
    dividerSection.schema.dividerSection,
    scrollAnchorSection.schema.scrollAnchorSection,
    imageActionCardsSection.schema.imageActionCardsSection,
    donationBoxSection.schema.donationBoxSection,
    legacySimulatorSection.schema.legacySimulatorSection
]);
export default {
    schema: schema
};

//# sourceMappingURL=page.js.map